import { apiClient } from "./apiClient";
import {
  setEventPointsListDetails,
  setTermDataListDetails,
} from "../redux/TermDataReducer/TermDataSlice";
import { setSnackbarDetails } from "../redux/AuthReducer/AuthSlice";
import { dispatchEmployeeListData } from "../redux/EmployeeReducer/EmployeeSlice";
import {
  setActiveReward,
  setEmployeeRewardData,
  setEmployeeRewardPaginatedData,
  setTermCodeValue,
} from "../redux/RewardReducer/RewardsSlice";
import { setStudentListData } from "../redux/super_admin/studentsReducer/StudentsSlice";
import { setPlcEventDetails } from "../redux/plc/EventsReducer/EventsSlice";
import { setEventCategoryListRedux } from "../redux/DTS/EventCategoryReducer/EventCategorySlice";
import { SetStateAction } from "react";

export interface employeePaginatedDetails {
  total: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export interface paginatedDetails {
  total: number;
  pageNumber: number;
  rowsPerPage: number;
  totalPages: number;
}

export const fetchEventpointsList = async (dispatcher: any) => {
  try {
    let res = await apiClient.get<any>("/oc/term-data/event-points/list");
    dispatcher(setEventPointsListDetails(res?.data?.data));
    return res;
  } catch (error) {
    throw error;
  }
};

export const fetchTermCodeListGoalPoints = async () => {
  try {
    let res = await apiClient?.get<any>("/oc/term-data/goal-points/list");
    return res?.data?.data ?? [];
  } catch (error) {
    throw error;
  }
};

export const fetchOCEventsList = async (
  dispatcher: any,
  value: string,
  termCode: string,
) => {
  try {
    let res = await apiClient?.get<any>(
      `/oc/events/list?eventName=${value}&termCodeId=${termCode}`,
    );
    return res?.data?.data.events;
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.message ?? "Failed to Fetch The Events List!",
      }),
    );
    return null;
  }
};

export const fetchEmployeeList = async (
  paginationData: employeePaginatedDetails,
  searchValue: string,
  dispatcher: any,
) => {
  const params = new URLSearchParams({
    pageNumber: paginationData?.pageNumber?.toString() ?? "1",
    pageSize: paginationData?.pageSize?.toString() ?? "15",
  });

  if (searchValue.trim() !== "") {
    params.append("employeeName", searchValue.trim());
  }
  try {
    let res = await apiClient?.get<any>(`/employees/list?${params.toString()}`);
    dispatcher(dispatchEmployeeListData(res?.data?.data?.employees));
    return res?.data?.data;
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.message ??
          "Failed to Fetch The Employee List!",
      }),
    );
    return null;
  }
};

export const getEmployeesEligibleForRewards = async (
  tab: string,
  termCode: string,
  paginationData: any,
  searchValue: string,
  dispatcher: any,
) => {
  const params = new URLSearchParams({
    pageNumber: paginationData?.pageNumber?.toString() ?? "1",
    pageSize: paginationData?.rowsPerPage?.toString() ?? "15",
    termCodeId: termCode,
  });

  if (searchValue.trim() !== "") {
    params.append("search", searchValue.trim());
  }
  let url =
    tab === "eligible"
      ? `/oc/rewards/term/eligible?${params.toString()}`
      : `/oc/rewards/term/not-eligible?${params.toString()}`;
  try {
    const res = await apiClient.get<any>(url);
    dispatcher(setEmployeeRewardData(res?.data?.data?.employees));
    dispatcher(
      setEmployeeRewardPaginatedData({
        pageNumber: res?.data?.data?.pagination?.pageNumber ?? 1,
        totalPages: res?.data?.data?.pagination?.totalPages ?? 1,
        rowsPerPage: res?.data?.data?.pagination?.pageSize ?? 15,
      }),
    );
    //return res?.data?.data ?? [];
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.message ??
          "Failed to Fetch The Eligible Employee List!",
      }),
    );
    return null;
  }
};

export const getListTermCodes = async (dispatcher: any) => {
  try {
    let res = await apiClient.get<any>("/oc/term-data/term-codes/list");
    let activeWard = res?.data?.data.find((item: any) => item.rewardToggleOn);
    // return res?.data?.data ?? [];
    dispatcher(setTermDataListDetails(res?.data?.data));
    // localStorage.setItem(
    //   "oc_all_in_termCodes",
    //   JSON.stringify(res?.data?.data),
    // );
    dispatcher(setTermCodeValue(res?.data?.data?.[0]?.id));
    dispatcher(setActiveReward(activeWard ?? null));
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error.response?.data?.message ??
          "Failed to Fetch The Term Codes List!",
      }),
    );
    return null;
    // console.log(error);
  }
};

export const getRewardTypeList = async (dispatcher: any) => {
  try {
    let res = await apiClient?.get<any>(`/reward-type/list`);
    return res?.data?.data;
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          "Failed to Fetch The Rewards Type List",
      }),
    );
    return null;
  }
};

export const handleImport = async (
  file: File | null,
  dispatcher: any,
  setProgress: (progress: number) => void,
  setUploading: (status: boolean) => void,
) => {
  if (!file) return;
  try {
    const formData = new FormData();
    formData.append("file", file);
    let res = await apiClient?.post<any>(`/employees/bulk-create`, formData, {
      onUploadProgress: (progressEvent: any) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
        setProgress(percentCompleted);
      },
    });
    dispatcher(
      setSnackbarDetails({
        type: "success",
        message: `File Imported Successfully!, TotalProcessed: ${res?.data?.data?.data?.totalProcessed}, SuccessCount: ${res?.data?.data?.data?.successCount}, FailureCount:  ${res?.data?.data?.data?.failureCount}`,
      }),
    );
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          "Error in Uploading the XLSX File!",
      }),
    );
  } finally {
    setUploading(false);
  }
};

export const fetchEmployeesFullList = async (
  dispatcher: any,
  searchValue: string,
) => {
  try {
    let url = searchValue
      ? `/employees/list?employeeName=${searchValue}&export=true`
      : `/employees/dropdown`;
    let res = await apiClient?.get<any>(url);
    return res?.data?.data;
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          "Failed to Fetch The Employee List!",
      }),
    );
    return null;
  }
};

export const fetchPlcEventList = async (tab: string, dispatcher: any) => {
  try {
    let res = await apiClient?.get<any>(
      `/plc/events?eventMode=${tab}&export=true`,
    );
    dispatcher(setPlcEventDetails(res?.data?.data?.events));
    return res?.data?.data;
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          "Failed To Fetch The Event List!",
      }),
    );
    return null;
  }
};

export const fetchDtsEventCategory = async (dispatcher: any) => {
  try {
    let res = await apiClient?.get<any>(
      `/dts/master/event-categories?isActive=true`,
    );
    dispatcher(setEventCategoryListRedux(res?.data?.data));
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          "Failed to Fetch The Event Category List!",
      }),
    );
  }
};

export const fetchStudentsFullList = async (dispatcher: any) => {
  try {
    let res = await apiClient?.get<any>(`/students/list?&export=true`);
    const apiData = res?.data?.data;
    dispatcher(
      setStudentListData({
        students: apiData?.students ?? [],
        pagination: apiData?.pagination ?? {
          total: 0,
          pageNumber: 1,
          pageSize: 15,
          totalPages: 1,
        },
      }),
    );
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          "Failed to Fetch The Event Category List!",
      }),
    );
  }
};

export const fetchFileId = async (
  module: string,
  moduleUrl: string,
  file: any,
  dispatcher: any,
) => {
  let formData = new FormData();
  formData.append("file", file);
  formData.append("module", moduleUrl);
  try {
    let res = await apiClient?.post<any>(`${module}/files/upload`, formData);
    return res?.data?.data;
  } catch (error: any) {
    dispatcher(
      setSnackbarDetails({
        type: "error",
        message:
          error?.response?.data?.data?.message ??
          "Error In Uploading the File!",
      }),
    );
  }
};
